import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getCountOfTests } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
import { useLocation } from "react-router-dom";

const UseGetLabTestCount = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isLabPage = location.pathname === "/lab";

  return useQuery({
    queryKey: ["getCountOfTests"],
    queryFn: () => getCountOfTests(),  
    enabled: isLabPage,
    onError: () => {
      dispatch(setError(true));
      dispatch(setLoading(false));
    },
    onSettled: () => {
      dispatch(setLoading(false));
    },
    // staleTime: Infinity, // Keep the data fresh indefinitely
    cacheTime: 1000 * 60 * 60, // Cache the data for 1 hour
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
    refetchOnMount: false, // Don't refetch on component mount
  });
};

export default UseGetLabTestCount;
